export const TagSizes = ['sm', 'md', 'lg', 'xl'] as const;